import { axiosApi, axiosAuthApi } from "services/api";


// API function to filter creators by certain criteria
export const filterCreatorsApi = (token, data, page) => {
    return axiosApi.post(`/filter/creator?page=${page}`, data, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};

// API function to fetch favorite creators
export const getFavouriteCreatorsApi = async (token, page) => {
    // return axiosApi.get(`/get/my/favourite-creators?page=${page}`, {
    //     headers: {
    //         Authorization: `Bearer ${token}`,
    //     },
    // });

    try {
        const response = await axiosApi.get(`/get/my/favourite-creators?page=${page}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response?.data; // Return response if successful
    } catch (error) {
        throw error; // If error occurs, throw the error to be caught in the action
    }
};

// Function to filter creators' catalogue
export const filterCreatorsCatalogueApi = (token, data, page) => {
    return axiosAuthApi(token).post(`/filter/creator?page=${page}`, data);
};

// Function to get a single creator's details
export const getSingleCreatorApi = (token, data) => {
    return axiosApi.post("/get/creator", data, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};

export const getCreatorCampaigns = async (header, formData, page) => {
    try {
        const response = await axiosAuthApi(header).post(`/filter/campaign?page=${page}`, formData);
        return response; // Return response if successful
    } catch (error) {
        throw error; // If error occurs, throw the error to be caught in the action
    }
};

// API call to fetch creators with pagination
export const fetchCreators = async ({ token, creatorsCurrentPage }) => {
    try {
        const response = await axiosApi.get(`/get/creators?page=${creatorsCurrentPage}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data; // Assuming the response data is directly in `data`
    } catch (error) {
        throw error; // Throw the error to be handled by the action/reducer
    }
};

// API call for sending a collaboration request
export const sendCollaborationRequest = async (token, data) => {
    try {
        const response = await axiosApi.post("/collaboration/request/send", data, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data; // Return the response data
    } catch (error) {
        throw error; // Throw the error to be handled in the action/reducer
    }
};

// Action to accept an agency invite
export const acceptAgencyInviteApi = async (data) => {
    return await axiosApi.post("/accept/agency/invite", data);
};

// Action to reject an agency invite
export const rejectAgencyInviteApi = async (data) => {
    return await axiosApi.post("/reject/agency/invite", data);
};

// Action to disconnect Instagram
export const disconnectInstagramApi = async (token) => {
    return await axiosApi.get("/instagram/disconnect", {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};